import React, { useEffect, useState } from 'react'
import { Helmet } from 'react-helmet'
import HeaderTitle from "../../components/HeaderTitle/index";
import { Link } from 'react-router-dom';
import axios from 'axios';
import { useSelector } from 'react-redux';
import swal from 'sweetalert';

function Holidays() {
    const [holidays, setHolidays] = useState([])
    const { token, user, role } = useSelector((state) => state.auth)
    const getHolidayList = () => {
        axios.get(`${process.env.REACT_APP_SERVICE_URL}/holiday`, {
            headers: {
                Authorization: `Bearer ${token}`
            }
        })
            .then((response) => {
                console.log(response.data)
                setHolidays(response.data)
            })
            .catch((error) => {
                console.error(error)
                setHolidays([])
            })
    }

    const deleteHoliday = (id) => {
        swal({
            title: "Emin misiniz?",
            text: "Silmek istediğinize emin misiniz?",
            icon: "warning",
            buttons: true,
            dangerMode: true,
        })
            .then((willDelete) => {
                if (willDelete) {
                    axios.delete(`${process.env.REACT_APP_SERVICE_URL}/holiday/${id}`, {
                        headers: {
                            Authorization: `Bearer ${token}`
                        }
                    })
                        .then((response) => {
                            console.log(response.data)
                            getHolidayList()
                            swal("Tatil başarıyla silindi", {
                                icon: "success",
                            });
                        })
                        .catch((error) => {
                            console.error(error)
                            swal("Tatil silinirken bir hata oluştu", {
                                icon: "error",
                            });
                        })
                }

            });
    }

    useEffect(() => {
        getHolidayList()
    }, [])

    return (
        <div className='container-fluid'>
            <Helmet>
                <title>Tatil Günleri</title>
                <meta name='description' content='Holiday Page' />
            </Helmet>

            <HeaderTitle title='Tatil Günleri' description={'Tatil Günleri Sayfası'} />

            <div className='row'>
                <div className='col-md'>
                    <div className='d-flex flex-wrap gap-2 mb-1'>
                        <Link to='/holidays/create' className='btn btn-dark btn-app'>
                            <i className='bi bi-plus-lg'></i>
                            Tatil oluştur
                        </Link>
                    </div>
                </div>
            </div>

            <div className='row my-3'>
                <div className='col-12'>
                    <div className='table-responsive'>
                        <table className='table table-striped table-hover table-bordered'>
                            <thead>
                                <tr>
                                    <th>#</th>
                                    <th>Tarih</th>
                                    <th>Başlangıç Saati</th>
                                    <th>Bitiş Saati</th>
                                    <th>Tüm Gün</th>
                                    <th>İşlemler</th>
                                </tr>
                            </thead>
                            <tbody>
                                {
                                    holidays.content && holidays.content.map((item) => {
                                        return (
                                            <tr key={item.id}>
                                                <td className='align-middle'>{item.id}</td>
                                                <td className='align-middle'>{item.date}</td>
                                                <td className='align-middle'>{item.openTime}</td>
                                                <td className='align-middle'>{item.closeTime}</td>
                                                <td className='align-middle'>
                                                    {
                                                        item.allDay ? 'Evet' : 'Hayır'
                                                    }
                                                </td>
                                                <td className='align-middle'>
                                                    <div className='d-inline-flex flex-wrap align-items-center gap-1'>
                                                        <Link to='/holidays/update' state={{ holiday: item }} className='btn btn-outline-primary btn-app'>Güncelle</Link>
                                                        <button type="button" onClick={() => deleteHoliday(item.id)} className='btn btn-outline-danger btn-app'>Sil</button>
                                                    </div>
                                                </td>
                                            </tr>
                                        )
                                    })
                                }
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default Holidays